import * as ymaps from 'ymaps';

export default class YmapsModal {

    map;
    mapContainer;
    modal;
    overlay;
    closeBtn;
    id;
    trackUrl;

    constructor(modal) {
        this.modal = modal;

        if (!this.modal) {
            return;
        }

        this.mapContainer = this.modal.querySelector('.slope-map-modal__map');
        this.closeBtn = this.modal.querySelector('.slope-map-modal__close');
        this.overlay = this.modal.querySelector('.slope-map-modal__overlay');
        this.id = this.modal.dataset.map;
        this.trackUrl = this.modal.dataset.track;

        if (!this.mapContainer) {
            return;
        }

        this.loadMap();
        this.addListeners();
    }

    async loadMap() {
        ymaps.ready(() => {
        
            this.map = new ymaps.Map(this.mapContainer, {
                center: [56.241426, 38.209191],
                zoom: 16,
                controls: []
            });

            if (!this.trackUrl) {
                return;
            }
            
            ymaps.geoXml.load(this.trackUrl)
                .then((res) => {
                    res.geoObjects.options.set({
                        strokeWidth: 10,
                        strokeColor: "2409edc9",
                        geodesic: true,
                    });

                    this.map.geoObjects.add(res.geoObjects);
                });
        });
    }

    addListeners() {
        if (this.closeBtn && this.overlay) {
            [this.closeBtn, this.overlay].forEach(b => {
                b.addEventListener('click', () => {
                    this.close();
                });
            });
        }

        if (this.id) {
            Array.from(document.querySelectorAll(`[data-open-map="${this.id}"]`)).forEach(b => {
                b.addEventListener('click', () => {
                    this.open();
                });
            });
        }
    }

    close() {
        this.modal.classList.remove('opened');
    }

    open() {
        this.modal.classList.add('opened');
    }
}
